// extracted by mini-css-extract-plugin
export var checkList = "checkList-module--checkList--c1ebb";
export var wrapper = "checkList-module--wrapper--a0bc8";